export interface AnError {
    domain: string | null,
    message: string | null
}

export default function parseAnError(data: any): AnError {
    if (data && data.domain && data.message) {
        return data as AnError
    } else {
        return {
            domain: null,
            message: null
        }
    }
}